export const DEFAULT_DATE_TIME_PLACEHOLDER = "2025-10-21 14:30:00";
